export const cleanNotNumbersAcceptDot = (value) => value.replace(/[^0-9.]/g, "")
export const cleanNotNumbers = (value) => value.replace(/[^0-9]/g, "")
